import React from 'react';
import Loadable from 'react-loadable';

import { HomePageLoadingState } from './components/LoadingState/LoadingState';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsHomePageWidget" */ './SportsHomePageWidget'),
  modules: ['./SportsHomePageWidget'],
  loading: () => <HomePageLoadingState />
});

export default LoadableWidget;
